<template>
    <div class="questions">
        <div class="question-box" v-if="items">
            <div v-for="(item , index) in items" :key="item">
                <div class="main-section">
                    <h5  @click="showText(index)">
                        <img height="20" width="20" src="../assets/new/New/Icon/QuestionMark.png" alt="">
                       {{item.question}}
                    </h5>
                    <img :style="{transform: 'rotate(' + (clickedItem === index ? '180deg' : 0) + ')'}"  height="7" width="5" src="../assets/new/New/Icon/Filled/ArrowDownnn.png" alt="" @click="showText(index)">
                </div>
                <p v-if="clickedItem === index">
                    {{item.answer}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name:'Questions',
        props:['items'],
        data(){
            return{
                clickedItem:''
            }
        },
        methods:{
            showText(num){
                if(this.clickedItem===num){
                    this.clickedItem=''
                }else{
                    this.clickedItem=num
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    .main-section{
        h5 {
            cursor: pointer;
        }
    }

    .small-div{
        min-height: 140px;
        div{
            padding: 10px;
            margin-top: 15px;
            width: 100%;
            height: 140px;
            background-color: #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                margin: 20px;
            }
            image{

            }
        }
    }
    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul{
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            padding: 0;
            li{

                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
        }

    }
    .questions{
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .questions>h3{
        margin-top: 100px;
        margin-left: 73%;
        font-size: 25px;
    }

    .question-box{
        width: 100%;
        background: transparent;
    }

    .question-box>div{
        margin: 10px 0;

        border-bottom: solid 1px #cc171d;

        background-color: #ffffff;


        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: right;
        padding: 17px 0;
    }

    .main-section{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .main-section>img{
        width: 10px;
        height: 7px;
        cursor: pointer;
    }

    .question-box p{
        display: block;

        font-size: 14px;

        font-weight: 500;

        font-stretch: normal;

        font-style: normal;

        line-height: normal;

        letter-spacing: normal;

        text-align: justify;

        color: #1a1a1a;

        margin-top: 15px;
    }
    h5{
        font-family: IRANSans;
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #1a1a1a;
        padding: 0;
    }


</style>